// src/utils/patchFetch.js
import { apiFetch } from "./apiFetch";

(function ensurePatched() {
  const WIN = window;

  // Si déjà patché, on s'assure d'avoir conservé l'original, puis on sort
  if (WIN.fetch && WIN.fetch.__IS_FETCH_PATCH__) {
    if (!WIN.__FETCH_ORIGINAL__ && WIN.fetch.__ORIGINAL__) {
      WIN.__FETCH_ORIGINAL__ = WIN.fetch.__ORIGINAL__;
    }
    return;
  }

  // Déterminer l'original de façon sûre (privilégie un original déjà sauvé)
  const original =
    (typeof WIN.__FETCH_ORIGINAL__ === "function" && WIN.__FETCH_ORIGINAL__) ||
    (WIN.fetch &&
      WIN.fetch.__IS_FETCH_PATCH__ &&
      typeof WIN.fetch.__ORIGINAL__ === "function" &&
      WIN.fetch.__ORIGINAL__) ||
    WIN.fetch;

  function wrappedFetch(input, init) {
    return apiFetch(input, init);
  }

  // Taguer pour détection future et stocker l'original dans le wrapper aussi
  Object.defineProperty(wrappedFetch, "__IS_FETCH_PATCH__", { value: true });
  Object.defineProperty(wrappedFetch, "__ORIGINAL__", { value: original });

  WIN.__FETCH_ORIGINAL__ = original;
  WIN.fetch = wrappedFetch;
  WIN.__FETCH_PATCHED__ = true;
})();
